
export default {
  props: {
    to: {
      type: String,
      default: '/'
    }
  }
};
